import { ApplyFilter, FilterInputData } from '../../../FilterTypes'
import { Swatch } from '@corratech/pylot-swatches'
import React from 'react'
import s from '../FilterList.module.scss'
import { VisualSwatch } from '@components/common/ProductTile/ColorTiles/VisualSwatch'
import cn from 'classnames'

type MultiselectInputProps = {
    applyFilter: ApplyFilter
    showCount?: boolean
    isChecked: boolean
    filterTypeInput: FilterInputData
    count: number
    isLoading?: boolean
    statusArray: boolean[]
    availableValues?: string[] | null
    index: number
    isHorizontal?: boolean
    initialFilterAttribute?: string | null
}

const MultiselectInput = ({
    applyFilter,
    showCount,
    isChecked,
    filterTypeInput,
    count,
    isLoading,
    statusArray,
    availableValues,
    index,
    isHorizontal,
    initialFilterAttribute
}: MultiselectInputProps): JSX.Element => {
    const { value_string, requestVar, label } = filterTypeInput

    const isGroupColor = requestVar == 'grupo_color'

    const isCheckboxDisabled = (value?: string, idx?: number): boolean => {
        if (isLoading) return true
        if (!value) return false

        if (idx !== undefined && statusArray[idx]) {
            return false
        }

        const isInitialAttribute = requestVar === initialFilterAttribute

        if (isInitialAttribute) {
            return false
        }

        return !availableValues?.includes(value)
    }

    const isDisabled = isCheckboxDisabled(value_string, index)

    if (requestVar == 'size') {
        return (
            <div>
                <Swatch
                    isCircle
                    active={isChecked}
                    label={label!}
                    disabled={isDisabled}
                    onClick={() =>
                        isDisabled
                            ? {}
                            : applyFilter(filterTypeInput, !isChecked)
                    }
                />
            </div>
        )
    }

    return (
        <div
            onClick={() =>
                isDisabled ? {} : applyFilter(filterTypeInput, !isChecked)
            }
            onKeyDown={(e) => {
                if (e.key === 'Enter' && !isDisabled) {
                    applyFilter(filterTypeInput, !isChecked)
                }
            }}
            role="button"
            tabIndex={0}
        >
            <label
                className={cn(s['root-checkbox'], 'pointer-events-none')}
                htmlFor={`product_checkbox_${requestVar}_${value_string}_${
                    isHorizontal ? 'hr' : 'vr'
                }`}
            >
                <span className={s['checkbox-container']}>
                    <input
                        type="checkbox"
                        name={value_string}
                        id={`product_checkbox_${requestVar}_${value_string}_${
                            isHorizontal ? 'hr' : 'vr'
                        }`}
                        disabled={isDisabled}
                        className={s['input-checkbox']}
                        checked={isChecked}
                    />
                    {isGroupColor && (
                        <div
                            className={cn(
                                s['group-color-container'],
                                isChecked ? s['checked'] : ''
                            )}
                        >
                            <VisualSwatch
                                disabled={isDisabled}
                                option={filterTypeInput}
                                styles={{
                                    margin: '0',
                                    width: '15px',
                                    height: '15px'
                                }}
                            />
                        </div>
                    )}
                    <span
                        className={cn(
                            s['label-checkbox'],
                            isGroupColor ? s['color-label-checkbox'] : ''
                        )}
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: String(label)
                            }}
                        />
                        {showCount && (
                            <span className={s['count']}>({count})</span>
                        )}
                    </span>
                </span>
            </label>
        </div>
    )
}

const MemoMultiselectInput = React.memo(MultiselectInput)

export { MemoMultiselectInput }
